export const usePriorityGridStyles = () => ({
    gridBoxStyles: {
        flexGrow: 1,
        mx: 1,
    },
    gridContainerStyles: {
        alignItems: "stretch",
    },
    gridItemStyles: {
        display: "flex",
        alignItems: "center",
    },
    gridItemCenteredStyles: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
});
